import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      {/* Footer */}
      <footer className="w-full py-8 px-4 relative" style={{
      background: '#060e1a',
      borderTop: '1px solid rgba(201, 168, 76, 0.15)'
    }} data-id="element-108">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-109">
          {/* Brand */}
          <p className="font-heading italic text-lg" style={{
          color: 'var(--color-gold-dim)'
        }} data-id="element-110">
            El Código de la Longevidad Bíblica
          </p>

          {/* Links */}
          <div className="flex items-center gap-6" data-id="element-111">
            <button onClick={() => setActiveModal('privacy')} className="font-body text-sm transition-colors hover:underline" style={{
            color: 'var(--color-cream-muted)'
          }} data-id="element-112">
              Política de Privacidad
            </button>
            <span style={{
            color: 'rgba(201, 168, 76, 0.3)'
          }} data-id="element-113">
              ✦
            </span>
            <button onClick={() => setActiveModal('terms')} className="font-body text-sm transition-colors hover:underline" style={{
            color: 'var(--color-cream-muted)'
          }} data-id="element-114">
              Términos y Condiciones
            </button>
          </div>

          {/* Copyright */}
          <p className="font-body text-xs" style={{
          color: 'rgba(197, 185, 165, 0.4)'
        }} data-id="element-115">
            © {new Date().getFullYear()} El Código de la Longevidad Bíblica.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-116">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
        background: 'rgba(6, 14, 26, 0.92)',
        backdropFilter: 'blur(6px)'
      }} onClick={() => setActiveModal(null)} data-id="element-117">
            <motion.div initial={{
          opacity: 0,
          y: 30,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-2xl p-8 md:p-10" style={{
          background: 'linear-gradient(135deg, #0f1f3d 0%, #0a1628 100%)',
          border: '1px solid rgba(201, 168, 76, 0.3)',
          boxShadow: '0 0 60px rgba(201, 168, 76, 0.08), 0 20px 60px rgba(0,0,0,0.7)'
        }} onClick={e => e.stopPropagation()} data-id="element-118">
              {/* Close button */}
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center font-body text-lg transition-colors" style={{
            background: 'rgba(201, 168, 76, 0.1)',
            border: '1px solid rgba(201, 168, 76, 0.25)',
            color: 'var(--color-gold)'
          }} data-id="element-119">
                ×
              </button>

              {/* Gold top accent */}
              <div className="absolute top-0 left-0 right-0 h-px rounded-t-2xl" style={{
            background: 'linear-gradient(90deg, transparent, var(--color-gold), transparent)'
          }} data-id="element-120" />

              {activeModal === 'privacy' ? <PrivacyContent data-id="element-121" /> : <TermsContent data-id="element-122" />}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <div data-id="element-123">
      <h2 className="font-heading font-700 text-3xl md:text-4xl mb-2" style={{
      color: 'var(--color-cream)'
    }} data-id="element-124">
        Política de Privacidad
      </h2>
      <div className="h-px mb-6" style={{
      background: 'linear-gradient(90deg, var(--color-gold-dim), transparent)'
    }} data-id="element-125" />

      <div className="space-y-5 font-body text-sm leading-relaxed" style={{
      color: 'var(--color-cream-dim)'
    }} data-id="element-126">
        <Section title="1. Información que Recopilamos" data-id="element-127">
          Al realizar una compra, recopilamos únicamente la información
          necesaria para procesar tu pedido: nombre, dirección de correo
          electrónico y datos de pago procesados de forma segura por nuestro
          proveedor de pagos. No almacenamos información de tarjetas de crédito
          en nuestros servidores.
        </Section>

        <Section title="2. Uso de la Información" data-id="element-128">
          La información recopilada se utiliza exclusivamente para: (a) procesar
          y entregar tu compra, (b) enviarte el acceso a los materiales
          digitales adquiridos, y (c) comunicarte actualizaciones relevantes
          sobre tu producto. No vendemos, alquilamos ni compartimos tu
          información personal con terceros.
        </Section>

        <Section title="3. Seguridad de los Datos" data-id="element-129">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Todas las transacciones se realizan
          a través de conexiones cifradas SSL/TLS.
        </Section>

        <Section title="4. Cookies" data-id="element-130">
          Este sitio puede utilizar cookies técnicas necesarias para su
          funcionamiento. No utilizamos cookies de seguimiento publicitario de
          terceros sin tu consentimiento.
        </Section>

        <Section title="5. Tus Derechos" data-id="element-131">
          Tienes derecho a acceder, corregir o solicitar la eliminación de tu
          información personal en cualquier momento. Para ejercer estos
          derechos, puedes comunicarte con nosotros a través de los canales
          disponibles en este sitio.
        </Section>

        <Section title="6. Cambios a Esta Política" data-id="element-132">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación en este sitio.
        </Section>

        <p className="text-xs pt-2" style={{
        color: 'var(--color-cream-muted)'
      }} data-id="element-133">
          Última actualización: {new Date().getFullYear()}
        </p>
      </div>
    </div>;
}
function TermsContent() {
  return <div data-id="element-134">
      <h2 className="font-heading font-700 text-3xl md:text-4xl mb-2" style={{
      color: 'var(--color-cream)'
    }} data-id="element-135">
        Términos y Condiciones
      </h2>
      <div className="h-px mb-6" style={{
      background: 'linear-gradient(90deg, var(--color-gold-dim), transparent)'
    }} data-id="element-136" />

      <div className="space-y-5 font-body text-sm leading-relaxed" style={{
      color: 'var(--color-cream-dim)'
    }} data-id="element-137">
        <Section title="1. Aceptación de los Términos" data-id="element-138">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, aceptas quedar vinculado por estos Términos y Condiciones.
          Si no estás de acuerdo con alguna parte de estos términos, te pedimos
          que no realices ninguna compra.
        </Section>

        <Section title="2. Descripción del Producto" data-id="element-139">
          "El Código de la Longevidad Bíblica" es un producto de información
          digital diseñado con fines educativos y de bienestar general. No
          constituye asesoramiento médico, diagnóstico ni tratamiento de ninguna
          condición de salud.
        </Section>

        <Section title="3. Aviso Médico Importante" data-id="element-140">
          El contenido de este programa es únicamente informativo. Siempre
          consulta con un profesional de la salud calificado antes de realizar
          cambios en tu dieta, rutina de ejercicio o estilo de vida,
          especialmente si tienes condiciones médicas preexistentes o tomas
          medicamentos recetados.
        </Section>

        <Section title="4. Propiedad Intelectual" data-id="element-141">
          Todo el contenido incluido en este producto — textos, gráficos,
          protocolos y materiales — es propiedad exclusiva de sus creadores y
          está protegido por las leyes de derechos de autor. Queda estrictamente
          prohibida su reproducción, distribución o reventa sin autorización
          escrita.
        </Section>

        <Section title="5. Política de Reembolso" data-id="element-142">
          Dado que se trata de un producto digital con acceso inmediato, todas
          las ventas son finales. Si experimentas problemas técnicos para
          acceder a tu compra, contáctanos y trabajaremos para resolverlo.
        </Section>

        <Section title="6. Limitación de Responsabilidad" data-id="element-143">
          Los resultados individuales pueden variar. No garantizamos resultados
          específicos. El uso de este programa es bajo tu propia responsabilidad
          y discreción.
        </Section>

        <Section title="7. Ley Aplicable" data-id="element-144">
          Estos términos se rigen por las leyes aplicables en la jurisdicción
          del proveedor del servicio. Cualquier disputa será resuelta de buena
          fe entre las partes.
        </Section>

        <p className="text-xs pt-2" style={{
        color: 'var(--color-cream-muted)'
      }} data-id="element-145">
          Última actualización: {new Date().getFullYear()}
        </p>
      </div>
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-146">
      <h3 className="font-heading font-600 text-base mb-1" style={{
      color: 'var(--color-gold)'
    }} data-id="element-147">
        {title}
      </h3>
      <p data-id="element-148">{children}</p>
    </div>;
}